import PrebookingsSection from './styled';

export default PrebookingsSection;
